// extracted by mini-css-extract-plugin
module.exports = {"container":"Events-module--container--k_v3f","event":"Events-module--event--32acE"};